import { validateDate } from './validateDate';
import { validateTime } from './validateTime';
export const validateDateTime = ({
  props,
  value,
  adapter
}) => {
  const dateValidationResult = validateDate({
    adapter,
    value,
    props
  });
  if (dateValidationResult !== null) {
    return dateValidationResult;
  }
  return validateTime({
    adapter,
    value,
    props
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/internals/utils/validation/validateDateTime.js
// module id = 429
// module chunks = 0